import * as Sentry from '@sentry/vue'
import CategoryApi from '@/api/category'

const GET_CATEGORIES_START = 'GET_CATEGORIES_START'
const GET_CATEGORIES_SUCCEEDED = 'GET_CATEGORIES_SUCCEEDED'
const GET_CATEGORIES_FAILED = 'GET_CATEGORIES_FAILED'

const GET_FEATURED_TEMPLATES_START = 'GET_FEATURED_TEMPLATES_START'
const GET_FEATURED_TEMPLATES_SUCCEEDED = 'GET_FEATURED_TEMPLATES_SUCCEEDED'
const GET_FEATURED_TEMPLATES_FAILED = 'GET_FEATURED_TEMPLATES_FAILED'

const GET_CATEGORY_DETAIL_START = 'GET_CATEGORY_DETAIL_START'
const GET_CATEGORY_DETAIL_SUCCEEDED = 'GET_CATEGORY_DETAIL_SUCCEEDED'
const GET_CATEGORY_DETAIL_FAILED = 'GET_CATEGORY_DETAIL_FAILED'

const _state = {
  categories: [],
  selectedCategoryData: {},
  isLoadingCategories: false,
  isLoadingFeaturedTemplates: false,
  isLoadingCategoryDetail: false,
}

const getters = {
  categories(state) {
    return state.categories
  },
  selectedCategoryData(state) {
    return state.selectedCategoryData
  },
  isLoadingCategories(state) {
    return state.isLoadingCategories
  },
  isLoadingFeaturedTemplates(state) {
    return state.isLoadingFeaturedTemplates
  },
  isLoadingCategoryDetail(state) {
    return state.isLoadingCategoryDetail
  },
}

const actions = {
  async getAllCategories({ commit }) {
    commit(GET_CATEGORIES_START)
    try {
      const res = await CategoryApi.getAllCategoriesV2({
        sortBy: 'order',
        sortDesc: false,
      })
      commit(GET_CATEGORIES_SUCCEEDED, res.data)
    } catch (e) {
      Sentry.captureException(e)
      commit(GET_CATEGORIES_FAILED, e)
    }
  },
  async getFeaturedTemplatesByCategories({ commit }) {
    commit(GET_FEATURED_TEMPLATES_START)
    try {
      const res = await CategoryApi.getFeaturedTemplates({
        isFeatured: true,
      })
      const featuredTemplatesByCategories = res
        .map((category) => category.featuredTemplate)
        .filter((featuredTemplate) => featuredTemplate)

      const selectedCategoryData = {
        PresentationsCategories: featuredTemplatesByCategories.map((template) => ({
          id: template.id,
          Presentation: template,
        })),
      }

      commit(GET_FEATURED_TEMPLATES_SUCCEEDED, selectedCategoryData)
    } catch (e) {
      Sentry.captureException(e)
      commit(GET_FEATURED_TEMPLATES_FAILED, e)
    }
  },
  async getCategoryDetail({ commit }, categoryId) {
    commit(GET_CATEGORY_DETAIL_START)
    try {
      const res = await CategoryApi.getCategoryDetail(categoryId)
      commit(GET_CATEGORY_DETAIL_SUCCEEDED, res)
    } catch (e) {
      Sentry.captureException(e)
      commit(GET_CATEGORY_DETAIL_FAILED, e)
    }
  },
}

const mutations = {
  [GET_CATEGORIES_START](state) {
    state.isLoadingCategories = true
  },
  [GET_CATEGORIES_SUCCEEDED](state, categories) {
    state.categories = categories
    state.isLoadingCategories = false
  },
  [GET_CATEGORIES_FAILED](state, error) {
    state.isLoadingCategories = false
    state.getCategoriesError = error
  },
  [GET_FEATURED_TEMPLATES_START](state) {
    state.isLoadingFeaturedTemplates = true
  },
  [GET_FEATURED_TEMPLATES_SUCCEEDED](state, selectedCategoryData) {
    state.selectedCategoryData = selectedCategoryData
    state.isLoadingFeaturedTemplates = false
  },
  [GET_FEATURED_TEMPLATES_FAILED](state, error) {
    state.isLoadingFeaturedTemplates = false
    state.getFeaturedTemplatesError = error
  },
  [GET_CATEGORY_DETAIL_START](state) {
    state.isLoadingCategoryDetail = true
  },
  [GET_CATEGORY_DETAIL_SUCCEEDED](state, selectedCategoryData) {
    state.selectedCategoryData = selectedCategoryData
    state.isLoadingCategoryDetail = false
  },
  [GET_CATEGORY_DETAIL_FAILED](state, error) {
    state.isLoadingCategoryDetail = false
    state.getCategoryDetailError = error
  },
}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
